import { useEffect, useState } from 'react';
import classNames from 'classnames';

import * as Styles from './Pagination.styles';

const Pagination = ({
  totalPage,
  defaultPage = 1,
  onChange,
  className = '',
  mt = 'mt-5',
}) => {
  const [page, setPage] = useState(defaultPage);

  useEffect(() => {
    setPage(defaultPage);
  }, [defaultPage]);

  const handleChange = (event, value) => {
    setPage(value);
    if (onChange) {
      onChange(value);
    }
  };

  if (totalPage <= 1) {
    return null;
  }

  return (
    <div className={classNames('w-full flex justify-end', className, mt)}>
      <Styles.Pagination
        count={totalPage}
        page={page}
        onChange={handleChange}
        color="secondary"
        shape="rounded"
      />
    </div>
  );
};

export default Pagination;
